import { currencyDetailsPrototype } from './currency.protoTypes';

export class Currency {
	static getAssetList = () => Object.keys(currencyDetailsPrototype).map((key) => currencyDetailsPrototype[key]);

	static getList = (list = [], symbolProperty = 'SYMBOL') => {
		const newList = [];
		list.map((item) =>
			currencyDetailsPrototype[item[symbolProperty]]
				? newList.push({ ...currencyDetailsPrototype[item[symbolProperty]], ...item })
				: newList.push({ ...currencyDetailsPrototype['undefined'], ...item }),
		);
		return newList;
	};

	static getItem = (par = '') => {
		if (typeof par === 'object')
			return currencyDetailsPrototype[par.symbol] ? { ...par, ...currencyDetailsPrototype[par.symbol] } : par;
		else if (typeof par === 'string') return currencyDetailsPrototype[par] || null;
		else return null;
	};
}
